import PasswordChangeViewContainer from "@pathwright/web-new/src/views/auth/password/change/PasswordChangeViewContainer"
import PasswordCreateViewContainer from "@pathwright/web-new/src/views/auth/password/create/PasswordCreateViewContainer"
import { ConnectedProvider as SpaceConnectedProvider } from "@pathwright/web-new/src/views/space/api/context"
import { useRef } from "react"
import BGMode from "../../components/BGMode"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"

function UserAugmentationChangePassword({
  onContinue
}: {
  onContinue: () => void
}) {
  const { me } = usePathwrightContext()
  // Store the initial value of no_password_set to avoid re-rendering
  // when the password is changed, so as to let the LazyPasswordChangeContainer
  // handle success state.
  const initialHasPassword = useRef(!me.no_password_set).current

  return (
    <BGMode mode="light" px="2" pt={0} w="100%">
      <SpaceConnectedProvider>
        {initialHasPassword ? (
          <PasswordChangeViewContainer
            onContinue={onContinue}
            onCancel={onContinue}
            showHeading={false}
          />
        ) : (
          <PasswordCreateViewContainer
            onContinue={onContinue}
            onCancel={onContinue}
            showHeading={false}
          />
        )}
      </SpaceConnectedProvider>
    </BGMode>
  )
}

export default UserAugmentationChangePassword
